import React from "react";
import { useTranslation } from "react-i18next";
import { ElementRoot } from "./ElementRoot.jsx";
import AngLoader from "../../component.ang_loader.jsx";

export const PdfDocumentPreviewMessage = () => {
  const { t } = useTranslation();
  return (
    <ElementRoot loaded>
      <div className="ang_preview_message_wrapper">
        <div className="ang_preview_message_wrapper_inner">
          <div className="ang_preview_image ang_preview_image_document" />
          <div className="ang_preview_message">
            <p>{t("Preview of this document is being generated.")}</p>
            <p>{t("Preview will be shown as soon as it is done.")}</p>
            <AngLoader />
          </div>
        </div>
      </div>
    </ElementRoot>
  );
};
